import { render, staticRenderFns } from "./userSettingPage.vue?vue&type=template&id=6ee061bc&"
import script from "./userSettingPage.vue?vue&type=script&lang=ts&"
export * from "./userSettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports